import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'

export interface IHawkbitTarget {
  controllerId: string
  name: string
  description: string | null
  updateStatus: string | null
  lastControllerRequestAt: number | null
  ipAddress: string | null
  createdAt: number | null
  lastModifiedAt: number | null
}

export interface IHawkbitTargetPage {
  content: IHawkbitTarget[]
  total: number
  size: number
}

interface HawkbitTargetsData {
  hawkbitTargets: IHawkbitTargetPage
}

interface HawkbitTargetsVariables {
  limit: number
  offset: number
  query?: string | null
}

export const HAWKBIT_TARGETS_QUERY = gql`
  query HawkbitTargets($limit: Int, $offset: Int, $query: String) {
    hawkbitTargets(limit: $limit, offset: $offset, query: $query) {
      content {
        controllerId
        name
        description
        updateStatus
        lastControllerRequestAt
        ipAddress
        createdAt
        lastModifiedAt
      }
      total
      size
    }
  }
`

export const useHawkbitTargets = ({ limit, offset, query }: { limit: number; offset: number; query?: string | null }) => {
  return useQuery<HawkbitTargetsData, HawkbitTargetsVariables>(HAWKBIT_TARGETS_QUERY, {
    variables: { limit, offset, query },
    fetchPolicy: 'network-only'
  })
}
